import { useCallback, useMemo } from "react";
import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";
import { useSelector } from "react-redux";
import { getOrder } from "../../../store/order/selectors";
import useGetSearchResultsBound from "../../../hooks/useGetSearchResultsBound";

const util = createTrackingUtils({
  name: "flights_web_cat_southwest_airlines",
  defaultStage: 1,
  stages: {
    main: 1,
    desktop: 2,
    mobile: 3,
    direct: 4,
    meta: 5,
    solo: 6,
    nonsolo: 7,
    inbound: 8
  },
  goals: {
    clickPayNow: 1
  },
  goalsWithValue: []
});

export default function useFlightsWebSouthwest() {
  const { isAmerican, isSolo, isDirect, isDesktop } = useProfiler();
  const order = useSelector(getOrder);
  const isBound = !!useGetSearchResultsBound();

  const isVariant = useMemo(() => {
    if (!isAmerican()) return false;
    return !!util.trackWithDefaultStage();
  }, [isAmerican]);

  const trackStages = useCallback(() => {
    if (!isAmerican()) return;
    util.stages.main();
    isDirect() ? util.stages.direct() : util.stages.meta();
    isSolo() ? util.stages.solo() : util.stages.nonsolo();
    isDesktop() ? util.stages.desktop() : util.stages.mobile();
    if (isBound) {
      util.stages.inbound();
    }
  }, [isAmerican, isDirect, isSolo, isDesktop, isBound]);

  const isSouthwest = useMemo(
    () =>
      !!order?.airOrder.flightSegments.some(
        (segment) =>
          !!segment.legs.some(
            (leg) =>
              !!leg.carriersData.some((carr) => carr?.code?.toLowerCase() === "wn") ||
              !!leg.carriers.some((carr) => carr.toLowerCase() === "wn")
          )
      ),
    [order]
  );

  const trackCustomGoal = useCallback(() => {
    if (isSouthwest) util.goals.clickPayNow();
  }, [isSouthwest]);

  return {
    isVariant,
    trackStages,
    trackCustomGoal
  };
}
